// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"e7eb71a80351ffca","5375":"723d83f19b77d8d2"}[chunkId] + ".css";
};